import * as React from "react";
import useLookAndFeel from "hooks/useLookAndFeel";
import useInitialSetupReminder from "hooks/useInitialSetupReminder";
import { AppReducerState, initialState, reducer } from "reducers/AppReducer";
import { ThemeProvider } from "styled-components";
import { defaultTheme } from "styles/theme";
import { Outlet } from "react-router-dom";

export const AppContext = React.createContext<AppReducerState>({
    state: initialState,
    dispatch: () => null,
});

const App: React.FC = () => {
    const [state, dispatch] = React.useReducer(reducer, initialState);
    const stylesLoaded = useLookAndFeel(dispatch);
    const { tryRemindTenantAdminAboutShopConfiguration } =
        useInitialSetupReminder();

    React.useEffect(() => {
        tryRemindTenantAdminAboutShopConfiguration();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <AppContext.Provider value={{ state, dispatch }}>
            <ThemeProvider theme={defaultTheme}>
                {stylesLoaded && <Outlet />}
            </ThemeProvider>
        </AppContext.Provider>
    );
};

export default App;
